import {load} from '@shopify/theme-sections';
import '../sections/article-recipe';
import '../sections/more-recipes';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
});
